import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { UserService } from '../user.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private userService: UserService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const permittedRoles = route.data.roles;
    // console.log('permittedRoles', route.data.roles);
    return this.userService.currentUser.pipe(
      map((returnedUser: any) => {
        // console.log(returnedUser);
        if (returnedUser) {
          let isAuthenticated = false;

          permittedRoles.forEach((permittedRole: any) => {
            if (returnedUser.roles.find(role => role.id === permittedRole)) {
              isAuthenticated = true;
            }
          });

          if (isAuthenticated) {
            switch (returnedUser.status) {
              case 0:
                return this.router.parseUrl('/auth/register/message-mail-verify-user');
              default:
                return true;
            }
          } else {
            // this.userService.logOut().subscribe();
            localStorage.clear();
          }
        }
        return this.router.parseUrl('/auth/home');
      })
    );
  }
}
